module.exports = __webpack_public_path__ + "media/images/mailer-survey-request-surveys-completed-cac3585758193cd5bd9074d648e3ed35.png";